import { render, staticRenderFns } from "./ItensAdesaoBtnMaisAcoes.vue?vue&type=template&id=d4f6b940"
import script from "./ItensAdesaoBtnMaisAcoes.vue?vue&type=script&lang=js"
export * from "./ItensAdesaoBtnMaisAcoes.vue?vue&type=script&lang=js"
import style0 from "./ItensAdesaoBtnMaisAcoes.vue?vue&type=style&index=0&id=d4f6b940&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports